import moment from 'moment'
import type { DriverRankingPeriodAdminDto } from '@/backend/market'
import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DriverRankingPeriodEntity } from '../../domain/entities/DriverRankingPeriodEntity'

export class DriverRankingPeriodModel extends DriverRankingPeriodEntity {
  constructor(data: DriverRankingPeriodAdminDto) {
    super()
    mapEntityProperties(this, data, {
      map: {
        label: `${data.regionName ?? '-'} | ${formatDateOnly(data.startDate)} - ${formatDateOnly(data.endDate)}`
      }
    })
  }
}

function formatDateOnly(value?: string) {
  if (!value) return '-'
  return moment(value).format('YYYY-MM-DD')
}
